import { defineMessages } from 'react-intl';

export default defineMessages({
  subtitle: {
    id: 'search.subtitle',
    defaultMessage: 'PC and Steam Keys',
  },
  collections: {
    id: 'search.collections',
    defaultMessage: 'Collections',
  },
  genres: {
    id: 'search.genres',
    defaultMessage: 'Genres',
  },
  publishers: {
    id: 'search.publishers',
    defaultMessage: 'Publishers',
  },
  features: {
    id: 'search.features',
    defaultMessage: 'Features',
  },
  franchises: {
    id: 'search.franchises',
    defaultMessage: 'Franchises',
  },
  categories: {
    id: 'search.categories',
    defaultMessage: 'Categories',
  },
  themes: {
    id: 'search.themes',
    defaultMessage: 'Themes',
  },
  playstyles: {
    id: 'search.playstyles',
    defaultMessage: 'Play Styles',
  },
  'games-like': {
    id: 'search.games-like-plural',
    defaultMessage: 'Games Like',
  },
  games: {
    id: 'search.games',
    defaultMessage: 'Games',
  },
  dlc: {
    id: 'search.dlc',
    defaultMessage: 'DLC',
  },
  pcgames: {
    id: 'search.pcgames',
    defaultMessage: 'PC Games',
  },
  bundles: {
    id: 'search.bundles',
    defaultMessage: 'Bundles',
  },
  books: {
    id: 'search.books',
    defaultMessage: 'Books',
  },
  comics: {
    id: 'search.comics',
    defaultMessage: 'Comics',
  },
  audio: {
    id: 'search.audio',
    defaultMessage: 'Audio',
  },
  video: {
    id: 'search.video',
    defaultMessage: 'Video',
  },
  graphicnovel: {
    id: 'search.graphicnovel',
    defaultMessage: 'Graphic Novels',
  },
  software: {
    id: 'search.software',
    defaultMessage: 'Software',
  },
  elearning: {
    id: 'search.elearning',
    defaultMessage: 'E-Learning',
  },
  security: {
    id: 'search.security',
    defaultMessage: 'Security Products',
  },
  page: {
    id: 'search.page',
    defaultMessage: 'Page',
  },
  desc: {
    id: 'search.seodesc',
    defaultMessage: 'Get massive savings on exclusive Steam bundles and great games, updated daily. Join our community of over 2.6 million gamers - explore Fanatical now!',
  },
  'staff-picks': {
    id: 'collections.titles.staffpicks',
    defaultMessage: 'Staff Picks',
  },
  genresFacetDesc: {
    id: 'facetsearch.seodesc.genres',
    defaultMessage: 'Find the best deals on top {genres} PC games at Fanatical.',
  },
  featuresFacetDesc: {
    id: 'facetsearch.seodesc.feature',
    defaultMessage: 'Play it your way with the best deals on top {features} PC games at Fanatical.',
  },
  categoriesFacetDesc: {
    id: 'facetsearch.seodesc.categories',
    defaultMessage: 'Find the best deals on top {categories} PC games at Fanatical.',
  },
  themesFacetDesc: {
    id: 'facetsearch.seodesc.themes',
    defaultMessage: 'Find the best deals on top {themes} PC games at Fanatical.',
  },
  playstylesFacetDesc: {
    id: 'facetsearch.seodesc.playstyles',
    defaultMessage: 'Play it your way with the best deals on top {playstyles} PC games at Fanatical.',
  },
  franchisesFacetDesc: {
    id: 'facetsearch.seodesc.franchises',
    defaultMessage: 'Discover top deals on {type} from the {franchises} franchise.',
  },
  franchisesGameFacetDesc: {
    id: 'facetsearch.seodesc.franchises-game',
    defaultMessage: 'Play the next {franchises} game today.',
  },
  publishersFacetDesc: {
    id: 'facetsearch.seodesc.publishers',
    defaultMessage: 'Discover top deals on {type} published by {publishers}.',
  },
  publishersGameFacetDesc: {
    id: 'facetsearch.seodesc.publishers-game',
    defaultMessage: 'Play the latest games from {publishers} today.',
  },
  collectionsFacetDesc: {
    id: 'facetsearch.seodesc.collections',
    defaultMessage: 'Check out our handpicked collection of {collections} at Fanatical.',
  },
  collectionsGameFacetDesc: {
    id: 'facetsearch.seodesc.collections-game',
    defaultMessage: 'Check out our handpicked {collections} games at Fanatical.',
  },
  and: {
    id: 'facetsearch.list-and',
    defaultMessage: 'and',
  },
  all: {
    id: 'facetsearch.all',
    defaultMessage: 'All {categoryPlural}',
  },
  all_word: {
    id: 'facetsearch.allword',
    defaultMessage: 'All',
  },
  franchiseAutoCategories: {
    id: 'facet.description.franchise-auto-categories',
    defaultMessage: 'Find the best deals on {categories} {type} from the {name} franchise.',
  },
  autoCategories: {
    id: 'facet.description.auto-categories',
    defaultMessage: 'Find the best deals on {categories} {type} from {name}.',
  },
  autoFranchises: {
    id: 'facet.description.auto-franchises',
    defaultMessage: 'Featuring {type} from the {franchises} {count, plural, one { franchise} other {franchises}}.',
  },
  genre: {
    id: 'search.genre',
    defaultMessage: 'Genre',
  },
  feature: {
    id: 'search.feature',
    defaultMessage: 'Feature',
  },
  publisher: {
    id: 'search.publisher',
    defaultMessage: 'Publisher',
  },
  franchise: {
    id: 'search.franchise',
    defaultMessage: 'Franchise',
  },
  category: {
    id: 'search.category',
    defaultMessage: 'Category',
  },
  theme: {
    id: 'search.theme',
    defaultMessage: 'Theme',
  },
  playstyle: {
    id: 'search.playstyle',
    defaultMessage: 'Play Style',
  },
  topSellers: {
    id: 'search.top-sellers',
    defaultMessage: 'Top Sellers',
  },
  releaseDate: {
    id: 'search.release-date',
    defaultMessage: 'Release Date',
  },
  pricelowtohigh: {
    id: 'search.pricelowtohigh',
    defaultMessage: 'Price (low - high)',
  },
  gamesLike: {
    id: 'search.games-like',
    defaultMessage: 'See all games like {gameName}',
  },
  gamesLikeTitle: {
    id: 'games-like.title',
    defaultMessage: 'Games Like {gameName}',
  },
  gamesLikeTitleCount: {
    id: 'games-like.count-title',
    defaultMessage: '{count} Games Like {gameName}',
  },
  moreGamesLikeTitle: {
    id: 'games-like.more-title',
    defaultMessage: 'More PC Games Like {gameName}',
  },
  gamesLikeFranchiseLink: {
    id: 'games-like.more-franchise-link',
    defaultMessage: 'View all games in the {franchiseName} franchise',
  },
  topRated: {
    id: 'facetsearch.top-rated',
    defaultMessage: 'Top Rated',
  },
});
